
    import {defineComponent, reactive, ComputedRef, computed, watch} from 'vue'
    import {useRoute} from "vue-router";
    import {useStore} from "@/store";
    import  reportMsgUt from "@/util/reportMsg";


    interface State {
        channelType: string; // 家选 承诺100天
        antiFakeUrl: string;
        reportMsg: object;
        reportTipVersion: any;
        isShowAntiFake: any;
        orderDate: number;
        version240702: any;
        version240704: any;
        formatOrderDate: any;
    }
    export default defineComponent({
        name: "reminderText",
        setup() {
            let state: State = reactive({
                channelType: '',
                antiFakeUrl: '',
                reportMsg: {},
                reportTipVersion: null,
                isShowAntiFake: true,
                orderDate: 0,
                version240702: 0,
                version240704: 0,
                formatOrderDate: 0
            })
            
            state.reportMsg = reportMsgUt;
            const {query} = useRoute();
            state.channelType = `${query.channelType}` || '';
            // let reportCode = `${query.reportCode}` || '';
            // let reportDate = new Date('2024-3-21 19:00:00').getTime();
            
            // if (reportDate) {

            // }
            let store = useStore()
            let dataInfo: ComputedRef<{}> = computed<{}>(() => store.state.dataInfo)
            state.version240702 = computed(() => {
                return store.state.version240702 || 0
            })
            state.version240704 = computed(() => {
                return store.state.version240704 || 0
            })
            // 格式化时间
            function formatDate(dateTime) {
                if(!dateTime) {
                    return 0;
                }
                let reg1 = /[- :]/g;
                let dateNum = Number(dateTime.replace(reg1, ''));
                return dateNum
            }
            watch(dataInfo, (data: any) => {
                const {antiFakeUrl, reportTipVersion, reportDetectOrderVO, orderDate} = data
                state.antiFakeUrl = antiFakeUrl;
                state.reportTipVersion = reportTipVersion || null;
                state.orderDate = orderDate || 0;
                state.formatOrderDate = formatDate(orderDate);
                let reportGenDate = (reportDetectOrderVO && reportDetectOrderVO.reportGenDate) || '';
                let reg1 = new RegExp('-', 'g');
                let dateNum = Number(reportGenDate.replace(reg1, ''));
                if (state.reportMsg['RpCK']() && dateNum <= 20240321) {
                    state.isShowAntiFake = false
                } else {
                    state.isShowAntiFake = true
                }
                console.log('isShowAntiFake:', state.isShowAntiFake);
                console.log('dateNum:', dateNum);
                console.log('antiFakeUrl:', state.antiFakeUrl);
            }, {deep: true, immediate: true})
            return {
                state,
                formatDate
            }
        },
    })
